/**
 * Ivan 侧栏菜单 — 对照 site-112-48-27-232-8072/_menus.json
 * path 有值且非 stub → 挂现有 Vue 页；stub:true → IvanStub 占位
 * 可见性由 utils/ivanMenuAuth.js + config/role_menu_allow.json（Ivan 角色权限）裁剪
 * admin:true 仅作标注；实际以角色白名单 / local_menus 为准
 */
export const IVAN_MENU_GROUPS = [
  {
    group: '业务流程',
    items: [
      { text: '待办箱', path: '/todo' },
      { text: '待办日历', path: '/todo-calendar' },
      { text: '批量采样安排', path: '/pick/batch-arrange' },
      { text: '批量现场采样(按合同)', path: '/pick/batch-contract' },
      { text: '采样日历', path: '/pick/calendar' },
      { text: '采样管理', path: '/pick/doing' },
      { text: '样品管理', path: '/soil/handover' },
      { text: '检测任务安排', path: '/soil/arrange' },
      { text: '分析管理', path: '/soil' },
      { text: '理化任务队列', path: '/soil/lab-queue' },
      { text: '报告管理', path: '/reports' },
      { text: '周期任务管理', path: '/routine-admin' },
      { text: '周期任务安排', path: '/routine-plans' },
      { text: '任务监控', path: '/task-track' }
    ]
  },
  {
    group: '查询统计',
    items: [
      { text: '采样历史查询', path: '/stub/pick-history', stub: true },
      { text: '分析历史查询', path: '/stub/lab-history', stub: true },
      { text: '周期任务查询', path: '/routine-query' },
      { text: '订单管理', path: '/stub/business-admin', stub: true, admin: true },
      { text: '回款历史', path: '/stub/income-history', stub: true, admin: true },
      { text: '开票历史', path: '/stub/invoice-history', stub: true, admin: true }
    ]
  },
  {
    group: '资源管理',
    items: [
      { text: '企业管理', path: '/stub/enterprise', stub: true, admin: true, hint: '请在委托发起中通过企业选择器管理' },
      { text: '仪器管理', path: '/instruments' },
      { text: '标准物质管理', path: '/stub/std-solution', stub: true },
      { text: '合同管理', path: '/contracts', admin: true },
      { text: 'CMA能力范围', path: '/cma-scope', admin: true }
    ]
  },
  {
    group: '参数设置',
    items: [
      { text: '项目类型', path: '/setting/inspect-type', admin: true },
      { text: '项目因子', path: '/setting/item-factor', admin: true },
      { text: '监测类别', path: '/setting/project-type', admin: true },
      { text: '方法依据', path: '/setting/method-accord', admin: true },
      { text: '分析参数', path: '/setting/analyse-param', admin: true },
      { text: '监测费用', path: '/setting/monitor-fee', admin: true },
      { text: '报告模板', path: '/setting/report-tpl', admin: true },
      { text: '系统字典', path: '/setting/sys-dic', admin: true }
    ]
  },
  {
    group: '系统管理',
    items: [
      { text: '用户管理', path: '/admin/users', admin: true },
      { text: '部门管理', path: '/admin/department', admin: true },
      { text: '角色权限', path: '/admin/role', admin: true },
      { text: '数据导入', path: '/stub/data-import', stub: true, admin: true },
      { text: '超管配置', path: '/stub/super-config', stub: true, admin: true },
      { text: '流程设置', path: '/stub/wf-setting', stub: true, admin: true },
      { text: '模块配置', path: '/stub/mini-wf', stub: true, admin: true },
      { text: '登陆日志', path: '/admin/login-log', admin: true }
    ]
  }
]

export const NEW_CASE_MODELS = [
  { modelId: 'SimplifyMonitorEntrust', modelName: '委托发起流程', path: '/entrust/new' },
  { modelId: 'RoutineEntrustFlow', modelName: '周期任务执行', path: '/routine/new' },
  { modelId: 'SelfSendEntrustFlow', modelName: '来样检测业务流程', path: '/self-send/new' }
]
